import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["planningtype", "product", "productField", "productStatus"]
  static values = {
    selectCategory: String,
    costCategory: String,
    noProducts: String,
  }

  connect() {
    this.productOptions = Array.from(this.productTarget.options, (option) => option.cloneNode(true))
    this.filterProducts()
  }

  filterProducts() {
    const planningtypeId = this.planningtypeTarget.value
    const category = this.planningtypeTarget.selectedOptions[0]?.dataset.category
    const selectedProductId = this.productTarget.value
    const matchingOptions = this.productOptions.filter((option) => {
      return option.value === "" || option.dataset.planningtypeId === planningtypeId
    })

    this.productTarget.replaceChildren(
      ...matchingOptions.map((option) => option.cloneNode(true)),
    )

    const hasProducts = matchingOptions.some((option) => option.value !== "")
    const productAllowed = category === "revenue" && hasProducts
    const selectedStillAvailable = matchingOptions.some((option) => option.value === selectedProductId)

    this.productTarget.value = productAllowed && selectedStillAvailable ? selectedProductId : ""
    this.productFieldTarget.classList.toggle("d-none", !productAllowed)
    this.productStatusTarget.classList.toggle("d-none", productAllowed)
    this.productStatusTarget.textContent = this.statusText(planningtypeId, category, hasProducts)
  }

  statusText(planningtypeId, category, hasProducts) {
    if (!planningtypeId) return this.selectCategoryValue
    if (category === "spending") return this.costCategoryValue
    if (!hasProducts) return this.noProductsValue

    return ""
  }
}
